import { createAuthBaseQuery } from "@iotos/ims-auth-sdk/redux";
import type { RetryOptions } from "@reduxjs/toolkit/query";

import { imsAuthService } from "../../authentication/shared/ims-auth-service";
import { API_ENDPOINT } from "../../config/api";

const imsBaseQuery = createAuthBaseQuery(API_ENDPOINT, imsAuthService, {
  maxRetries: 1,
});

// TODO(IMS-SDK): убрать обёртку, когда SDK примет retryCondition
const shouldRetryRequest: NonNullable<RetryOptions["retryCondition"]> = (
  error,
  _args,
  { attempt, baseQueryApi, extraOptions }
) => {
  if (baseQueryApi.type === "mutation") {
    return false;
  }

  const maxRetries = extraOptions?.maxRetries ?? 1;
  if (!error || typeof error !== "object" || !("status" in error)) {
    return false;
  }
  return (
    attempt <= maxRetries &&
    (error.status === "FETCH_ERROR" ||
      error.status === "TIMEOUT_ERROR" ||
      error.status === 502 ||
      error.status === 503 ||
      error.status === 504)
  );
};

export const baseQuery: typeof imsBaseQuery = (args, api, extraOptions) =>
  imsBaseQuery(args, api, { retryCondition: shouldRetryRequest, ...extraOptions });
